<template>
  <el-table
      :data="data"
      style="width: 100%">
    <el-table-column v-for="(column, key) in tableColumns" :key="key"
         :sortable="false"
        :label="column"
        :prop="column">
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    data: {
      required: true
    },
  },
  data () {
    return {
      tableColumns: [],
    }
  },
  beforeMount() {
    if (this.data.length > 0) {
      this.tableColumns = Object.keys(this.data[0])
    }
  }
}
</script>
